/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import { initialGeoRegion, resetProfile, resetThresholdCrossingSettingAction,resetThresholdCrossingSettingSchedule, resetThresholdCrossingSettingRule, resetThresholdCrossingSettingProfile } from "../../../components/helpers";
import { setSelectedThresholdCrossingSettingRule, } from "./reducers";
import { IAdminState } from "./types";
import { LOCAL_STORAGE } from "../../../globals/globals";

const storedGeoRegionIds = (() => {
  try {
    const raw = localStorage.getItem(LOCAL_STORAGE.SELECTED_GEO_REGION_IDS);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
    }
  } catch { /* ignore */ }
  return [];
})();

export const initialState: IAdminState = {
  selectedGeoRegion: initialGeoRegion,
  selectedGeoRegionIds: storedGeoRegionIds,
  selectedGeoRegions: [],
  isCreateUser: false,
  showBanner: false,
  selectedProfile: resetProfile,
  isCreateProfile: false,
  isEditProfile: false,
  selectedDomain: "",
  severityValue: {},
  snmpValue: {},
  emailValue: {},
  isCreateSNMPGroup: false,
  isCreateEmailGroup: false,
  isAddNewUserFileMgmt: false,
  groupList: [],
  selectedNotificationGroup: { text: "System Default", value: "NONE" },
  snmpEmailGroups: {
    snmpGroups: [],
    emailGroups: [],
  },
  selectedSnmpGroup: {
    objectKey: "",
    parentKey: "",
    name: "",
    port: 0,
    ipAddressesList: "",
    enabled: false,
    community: "",
    version: 1,
    contextName: "",
    userName: "",
    authPassword: "",
    privPassword: "",
    authProtocol: "NO_AUTH",
    privProtocol: "NO_PRIV",
    enableHeartbeat: false,
    heartbeatInterval: 0,
    lastHeartbeatTrap: "",
  },
  snmpAgent: {
    agentVersion: "",
    port: 0,
    readComunity: "",
    writeComunity: "",
    engineId: "",
    userName: "",
    authProtocol: "",
    privProtocol: "",
    authPassword: "",
    privPassword: "",
  },
  selectedEmailGroup: {
    email: "",
    eventTypes: "",
    parentKey: "",
    objectKey: "",
    domainKey: "Initial Domain",
  },
  smtpEmail: {
    useSmtpAuth: false,
    smtpHost: "",
    smtpPort: "25",
    smtpUsername: "",
    smtpPassword: "",
    emailKey: "",
    useSmtpSsl: false,
    fromEmail: "",
    useSmtpTls: false,
    testEmail: "",
  },
  accessControlSettings: {
    minimumAgeDays: 0,
    expiryWarningDays: 0,
    minimumLength: 0,
    reusePreventionCount: 0,
    reusePreventionDays: 0,
    messageOfDay: '',
    accountLockoutEnabled: true,
    accountLockoutFailedCount: 0,
    inactivityLogoutDurationMinutes: 0,
    bannerEnabled: false,
    bannerTitle: ''
  },
  systemProperties: {
    contact: "",
    description: "",
    location: "",
    name: "",
    maintenanceModeSystem: false,
  },
  selectedTrapReceive: {
    port: "",
    receivePort: "8162",
    version: "",
    community: "",
    engineId: "",
    userName: "",
    authPassword: "",
    privacyPassword: "",
    authProtocol: "",
    privProtocol: "",
  },
  selectedUserFileMgmt: {
    id: 0,
    username: "",
    key: "",
  },
  currentSiteGroups: [],
  selectedSyslogReceiver: {
    id: {
      objectKey: "",
      parentkey: "",
    },
    hostname: "",
    port: 514,
    enabled: true,
    enabledList: "",
    description: "",
    action: "add",
  },
  serverConfig: {
    primary_address: "",
    secondary_address: "",
    observer_address: "",
    heartbeat_freqency: 0,
    missed_heartbeat_threshold: 0,
    secondary_username: "",
    secondary_password: "",
  },
  selectedTaskType: "DEVICE",
  selectedBulkFile: null,
  validatedOfflineErrors: [],
  successOfflineUploads: [],
  dataPollerProperties: {
    privatekey: "",
    port: 22,
    dbgEnable: false,
    kpiEnable: false,
    alarmEnable: false,
    enable: false,
    cmEnable: false,
    ebEnable: false,
    maxDays: 3,
    pubkey: "",
    host: ""
  },
  startDate: 24 * 60 * 60 * 1000,
  passwordSettings: {
    minimumLength: 0,
  },
  thresholdCrossingSettingProfileModelOpenMode : "Add",
  thresholdCrossingSettingActionModelOpenMode : "Add",
  thresholdCrossingSettingScheduleModelOpenMode : "Add",
  thresholdCrossingSettingRuleModelOpenMode : "Add",
  selectedThresholdCrossingSettingProfile : resetThresholdCrossingSettingProfile,
  selectedThresholdCrossingSettingAction: resetThresholdCrossingSettingAction,
  selectedThresholdCrossingSettingSchedule : resetThresholdCrossingSettingSchedule,
  selectedThresholdCrossingSettingRule : resetThresholdCrossingSettingRule,
  isThresholdCrossingSettingProfileCrud : false,
  isThresholdCrossingSettingActionCrud : false,
  isThresholdCrossingSettingScheduleCrud : false,
  isThresholdCrossingSettingRuleCrud : false
};
